module.exports = __webpack_public_path__ + "media/images/img_logo-white-eb91172aeff756706bc4188d42fa5d10.png";